import React, { useEffect, useState } from 'react';
import { useGetOrganizationProjectsQuery } from '../../../api/organizations.js';
import ThreeDotsLoader from '../../misc/ThreeDotsLoader.jsx';
import { Link } from 'react-router-dom';
import OrganizationProjectsCarousel from '../OrganizationProjectsCarousel.jsx';

const OrganizationProjects = ({ orgId, orgName }) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [allProjects, setAllProjects] = useState([]);
    const projectsPerPage = 10;

    const {
        data: projectsData,
        isLoading: projectsLoading,
        isFetching: projectsFetching
    } = useGetOrganizationProjectsQuery({ page: currentPage, per_page: projectsPerPage, id: orgId });

    const hasMorePages = projectsData?.response?.has_more_pages || false;

    const mergeProjects = (newProjects) => {
        setAllProjects((prevProjects) => {
            const existingIds = new Set(prevProjects.map((project) => project.id));
            const filteredNewProjects = newProjects.filter((project) => !existingIds.has(project.id));
            return [...prevProjects, ...filteredNewProjects];
        });
    };

    useEffect(() => {
        if (projectsData?.response?.projects) {
            mergeProjects(projectsData.response.projects);
        }
    }, [projectsData]);

    const handleLoadMore = () => {
        if (hasMorePages) {
            setCurrentPage((prevPage) => prevPage + 1);
        }
    };

    const queryParams = new URLSearchParams();
    queryParams.append('company', orgId);
    queryParams.append('company_name', orgName);

    return (
        <>
            {allProjects.length !== 0 ? (
                <div className='mt-4 py-4'>
                    <div className='flex justify-between'>
                        <div className='text-lg font-bold text-theme1-primary2'>Projects</div>
                        {hasMorePages && (
                            <Link
                                className='text-theme1-primary2'
                                to={'/projects/advanced-search?' + queryParams.toString()}
                            >
                                View All
                            </Link>
                        )}
                    </div>
                    {projectsLoading && currentPage === 1 ? (
                        <ThreeDotsLoader />
                    ) : (
                        <OrganizationProjectsCarousel items={allProjects || []} className='' orgId={orgId} />
                    )}
                </div>
            ) : null}
        </>
    );
};

export default OrganizationProjects;
